module.exports = __webpack_public_path__ + "static/media/encrypt-decrypt.59128601.PNG";